var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99438 0.00105919C0.89134 0.00192744 0.00011611 0.896498 0.00011611 1.99954V2.76532V13.0148V23.2642L8.47714e-05 24.0035C3.79528e-05 25.108 0.895372 26.0035 1.9999 26.0036L2.74193 26.0037H13.0001H23.2583L24.0003 26.0036C25.1047 26.0035 26 25.1081 26.0001 24.0037L26.0001 23.2642V13.0148V2.76532V2.00409C26.0001 0.899256 25.1043 0.00371676 23.9994 0.00408525L13.1419 0.00770656C8.10532 -0.00134576 4.19597 -0.000673772 1.99438 0.00105919ZM13.4648 5.50065C14.011 5.78281 14.0401 5.97911 14.0401 9.37323C14.0401 12.7592 14.0233 12.872 13.476 13.1548C12.9595 13.4217 12.365 13.2397 12.1035 12.7345C11.8909 12.3236 11.8905 6.33836 12.1032 5.92763C12.3642 5.42318 12.9559 5.23766 13.4648 5.50065ZM9.09548 8.19327C9.80457 8.62516 9.82641 9.19516 9.16469 9.9967C6.15332 13.644 8.7971 18.947 13.4317 18.5555C17.7739 18.1888 19.627 13.2152 16.6929 9.80257C16.313 9.36067 16.2501 8.98847 16.4904 8.60315C17.1694 7.51426 18.3408 8.11335 19.3676 10.0743C22.4181 15.9006 16.6536 22.472 10.4947 20.1894C5.88273 18.4802 4.31196 12.6831 7.42817 8.87228C8.11108 8.03712 8.54759 7.85943 9.09548 8.19327Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d4185a15ea8e24e6e165f5022cdd8590.svg";
export { ForwardRef as ReactComponent };